/*
 * @Author: zxf
 * @Date: 2021-12-15 10:26:32
 * @Description: file content
 * @FilePath: \neolix-map-sdk\src\render\RenderController.js
 */

import { SceneRegister } from "../register/SceneRegister.js";
import Singleton from './../clazz/Singleton';
import { Tiles } from './../utils/Tiles.js';
import SourceController from './../source/SourceController.js';
import Source from './../source/Source.js';
import { ScenePack } from "../register/ScenePack.js";
import { Object3D } from "../../libs/three.js/build/three.module.js";
export class RenderController extends Singleton{
    constructor(options) {
        super(options);
        this.datas = {};
        this.animation = null;
        this.status = false;
        this.viewer = options.viewer;
        this.featureReg = options.featureReg;
        this.featureConfig = options.featureConfig;
        this.themeConfig = options.themeConfig;
        this.renderReg = options.renderReg;
        this.currFeatureType = [];
        this.sceneRegister = SceneRegister.getInstance();
        this.tiles = Tiles.getInstance();
        this.sourceController = new SourceController();
        this.sourceServe = options.renderServer;
        this.qualityServer = options.qualityServer;
        this.themeServer = options.themeServer;
        this.taskId = options.taskId;
        this.trackServer = options.trackServer;
        this.trackLines = [];
        this.trackLineIds = [];
        this.currUnitIds = [];
        this.visibleFilters = [];

    }
    initRender() {
        // 初始化场景
        this.initfeedbackRender();
        for (const key in this.featureConfig) {
            if (Object.hasOwnProperty.call(this.featureConfig, key)) {
                const element = this.featureConfig[key];
                this.sceneRegister.addScene(element.featureType);
                this.sceneRegister.scenes[element.featureType].isHelper = element.isHelper;
                if(element.isChild) {
                    this.sceneRegister.scenes[element.featureType].renderType = 'relation';
                }
                else {
                    const source = new Source(element.featureType);
                    this.sourceController.add(source);
                    if(element.relationFeatures) {
                        this.sceneRegister.scenes[element.featureType].relationFeatures = element.relationFeatures;
                    }
                }
                this.sceneRegister.hideFeature(element.featureType);
            }
        }
        for (const key in this.themeConfig) {
            if (Object.hasOwnProperty.call(this.themeConfig, key)) {
                const element = this.themeConfig[key];
                this.sceneRegister.addScene(element.featureType);
                this.sceneRegister.scenes[element.featureType].renderType = 'theme';
                const source = new Source(element.featureType);
                this.sourceController.add(source);
                this.sceneRegister.hideFeature(element.featureType);
            }
        }
    }
    /**
     * @Author: zxf
     * @description: 设置当前要素
     * @param {*} featureType
     * @return {*}
     */    
    setCurrFeatureType(featureType) {
        this.currFeatureType = featureType;
    }

    /**
     * @Author: zxf
     * @description: 设置工单
     * @param {*} unitIds
     * @return {*}
     */    
    setCurrUnitIds(unitIds) {
        if(this.currUnitIds) {
            this.sceneRegister.clearAll(['track']);
            this.currUnitIds = unitIds;
            this.updateSource(this.currFeatureType);
            return;
        }

        this.currUnitIds = unitIds;
        
    }

    setCurrTrackLines(trackLines) {
        this.trackLines = trackLines;
        this.trackLineIds = trackLines.map(item => {
            return item.id;
        });
        
        const source = this.sourceController.getSource('track');
        source.clear();
    }
    /**
     * @Author: wangxueshun
     * @description: 专题图层根据要素某个属性控制要素的显隐
     * @param {*} filters
     * @return {*}
     */  
    setVisibleFilters(filters) {
        const mergefilters = {};
        filters.forEach(({originalType,attr,value,checked}) => {
          if(!mergefilters.hasOwnProperty(originalType)) {
              mergefilters[originalType] = []
          }
          mergefilters[originalType].push({
              attr,
              value,
              checked
          })
        })

        this.visibleFilters =mergefilters
        this.updateVisibleFilters()
    }
    /**
     * @Author: wangxueshun
     * @description: 专题图层根据filter更新要素的显隐
     * @param {*} filters
     * @return {*}
     */  
    updateSceneVisible(scene,filter) {
        if(!scene||!filter||!filter.length) {
            return
        }
        scene.traverse(item => {
            if(item.prop) {
              let visible = false;
              for(let i=0; i< filter.length ;i++) {
                const {attr,value,checked} = filter[i];
                if(item.prop[attr] ===value) {
                    visible = checked;
                    if(visible) {
                        break;
                    }
                }
              }
                item.visible=visible;
            }
        })
    }
     /**
     * @Author: wangxueshun
     * @description: 专题图层根据filter更新要素的显隐
     * @param {*} 
     * @return {*}
     */ 
    updateVisibleFilters() {
          const {visibleFilters,sceneRegister} = this;
        

          for( let feature in visibleFilters) {
            const scene = sceneRegister.scenes[feature];
            this.updateSceneVisible(scene,visibleFilters[feature])
            // scene.traverse(item => {
            // 	if(item.prop) {
            //       let visible = false;
            //       for(let i=0; i< visibleFilters[feature].length ;i++) {
            // 	    const {attr,value,checked} = visibleFilters[feature][i];
            // 		if(item.prop[attr] ===value) {
            // 			visible = checked;
            //             if(visible) {
            // 				break;
            // 			}
            // 		}
            //       }
            // 	//   item.visible=visible;
            // 	}
            // })
          }
          

    }
    setVisible() {
        const {sceneRegister,featureConfig,themeConfig,tiles,currFeatureType} = this;
        const {tiles:screenTiles,box} = tiles.getTilesByScreenBox();
        const scenes = {...sceneRegister.scenes};
			currFeatureType.forEach(theme => {
				const themeFig = themeConfig[theme];
				if(!themeFig||!themeFig.part) {
					return
				}
				const index = currFeatureType.findIndex(item => item==themeFig.part);
				if(~index) {
					delete scenes[themeFig.part]
				}else {
					delete scenes[theme]
				}
			  })

        for(let key in scenes) {
            if(key != 'feedback' && currFeatureType.includes(key)) {
                sceneRegister.hideFeature(key);

                if(featureConfig[key]&&featureConfig[key].server) {
                sceneRegister.showFeature(key);
                }

                let screenBox;
                if(featureConfig[key]) {
                    screenBox = featureConfig[key].screenBox ||1000;
                }else {
                    screenBox = themeConfig[key].screenBox ||1000;
                }    
              
                const scene = scenes[key];
                if(scene.tiles && Object.keys(scene.tiles).length > 0) {
                    for (const tilekey in scene.tiles) {
                       if (Object.hasOwnProperty.call(scene.tiles, tilekey)) {
                           const element = scene.tiles[tilekey];
                           const x = tilekey.split('_')[0];
                           const y = tilekey.split('_')[1];
                           if(!screenTiles.some(child => child.x == x && child.y == y)) {
                               element.visible = false;
                           } else {
                               element.visible = true;
                           }
                       }
                    }
                }
                const camera = this.viewer.scene.getActiveCamera();
                const limitScreenZ = camera.position.z;
				const limitScreenBox = box.xMax - box.xMin;
                if(scene.renderType === 'theme') {
                const partKey = themeConfig[key].part?themeConfig[key].part:key
                sceneRegister.hideFeature(partKey);
                    if(limitScreenZ < screenBox) {
						sceneRegister.showFeature(partKey);
					}
                if(limitScreenBox < screenBox) {
                  this.getThemeSource(screenTiles,key);
                  sceneRegister.showFeature(partKey);
				        }
                }else if(key == 'track' && limitScreenBox < screenBox) {
                    this.getTrackSource(screenTiles, key);
                    sceneRegister.showFeature(key);
                } else if(key == 'qualityPoint'&&limitScreenBox < screenBox) {
                    this.getQualitySource(screenTiles, key);
                    sceneRegister.showFeature(key);
                } else if(limitScreenBox < screenBox) {
                    if(!scene.renderType&&(featureConfig[key]&&!featureConfig[key].server)) {
                        this.getSource(screenTiles, key);
                    }
                    
                    sceneRegister.showFeature(key);
                }
                if(limitScreenZ < screenBox) {
					sceneRegister.showFeature(key);
				}
            } else if(key != 'feedback') {
                sceneRegister.hideFeature(key);
            }
        }
        sceneRegister.showFeature('temporaryFeedback');
        sceneRegister.showFeature('staticFeedback');
    }


    updateSource(types, tiles) {
        const {featureConfig,themeConfig,sceneRegister} = this;
        const {tiles:screenTiles,box} = this.tiles.getTilesByScreenBox();

        if(tiles) {
            tiles.forEach(tile => {
                if(!screenTiles.some((item) => item.x == tile.x && item.y == tile.y)) {
                    screenTiles.push(tile);
                }
            });
        }
        const temps = types.map(i => {
            if(themeConfig[i]&&themeConfig[i].part) {
                return themeConfig[i].part
            }
            return i
        });
        
        sceneRegister.clearSceneCache(true,temps);

        for (let i = 0; i < types.length; i++) {
          
            const type = types[i];
            let screenBox;
            if(featureConfig[type]) {
                screenBox = featureConfig[type].screenBox ||1000;
            }else {
                screenBox = themeConfig[type].screenBox ||1000;
            }  
            const server = featureConfig[type]&&featureConfig[type].server;
            const scene = sceneRegister.scenes[type];
            
            const limitScreenBox = box.xMax - box.xMin;

            if(scene.renderType === 'theme'&& limitScreenBox< screenBox) {
             this.getThemeSource(screenTiles,type,true);
            }else if(type === 'qualityPoint'&& limitScreenBox < screenBox) {
                this.getQualitySource(screenTiles, type, true);
            }else if(server) {
                server()
            }else if(!~['track'].indexOf(type) && scene.renderType !='relation'&& limitScreenBox < screenBox) {
                this.getSource(screenTiles, type, true);
            }
        }
    }
    getQualitySource(tiles, type, reload = false) {
        const source = this.sourceController.getSource(type);
        const tileNum = this.tiles.tileNum;
        for (let i = 0; i < tiles.length; i++) {
            const ele = tiles[i];
            const sourceData = source.getData();
            if (!Object.keys(sourceData).includes(`${ele.x}_${ele.y}`) || reload) {
                source.add([], `${ele.x}_${ele.y}`);
                this.qualityServer({
                    taskId: this.taskId,
                    unitId: this.currUnitIds,
                    coords: [ele.x * tileNum, ele.y * tileNum, (ele.x + 1) * tileNum, (ele.y + 1) * tileNum]
                }).then(res => {

                    const tile = this.sceneRegister.scenes[type].getTile(`${ele.x}_${ele.y}`);
                    source.add(JSON.parse(JSON.stringify(res)), `${ele.x}_${ele.y}`);

                    if (tile) {
                        tile.clear();
                        this.render(tile, type, res);
                    } else {
                        const tile = this.sceneRegister.scenes[type].addTile(`${ele.x}_${ele.y}`);
                        this.render(tile, type, res);
                    }
                    this.status = true;
                });
            }
        }
    }
    /**
	 * @Author: wxs
	 * @description: 更新临时图层temp的要素
	 * @param {*} type
	 * @return {*}
	 */
    updateTemporaryFeedback(data,type, isSymbol = false) {
        const {sceneRegister} = this;
        let layer = sceneRegister.tempScenes[type];
        if(!layer) {
            layer = new Object3D();
            sceneRegister.tempScenes[type] = layer;
            sceneRegister.scenes.temporaryFeedback.add(layer);
        }
        
        layer.clear();

        this.temporaryRender(layer, data, isSymbol);
        
        this.sceneRegister.showTempFeature(type);
        
        this.status = true;
    }
    getTrackSource(tiles, type, reload = false) {
        const source = this.sourceController.getSource(type);
        const tileNum = this.tiles.tileNum;
        const sourceData = source.getData();
        const trackLine = [];
        this.trackLines.forEach(element => {
            trackLine.push({id: element.id, targetDb: element.targetDb})
        })
        if(trackLine.length <=0) {
            return false;
        }
        for(let i = 0; i < tiles.length; i++) {
            const ele = tiles[i];
            if(!Object.keys(sourceData).includes(`${ele.x}_${ele.y}`) || reload) {
                source.add([], `${ele.x}_${ele.y}`);
                this.trackServer({trackLine: trackLine, coords: [ele.x * tileNum, ele.y * tileNum, (ele.x + 1) * tileNum, (ele.y + 1) * tileNum]}).then(res => {
                    const tile = this.sceneRegister.scenes[type].getTile(`${ele.x}_${ele.y}`);
                    if(tile) {
                        tile.clear();
                        this.render(tile, type, res);
                    } else {
                        const tile = this.sceneRegister.scenes[type].addTile( `${ele.x}_${ele.y}`);
                        this.render(tile, type, res);
                    }
                    source.add(res, `${ele.x}_${ele.y}`);
                    this.status = true;
                })
            }
        }
        // this.trackLines.forEach(element => {
        //     if(!Object.keys(sourceData).includes(element.id) || reload) {
        //         this.trackServer({ trackLine: [{id: element.id, targetDb: element.targetDb}, coords: []] }).then(res => {
        //             const tile = this.sceneRegister.scenes[type].getTile(element.id);
        //             res.forEach((item, index) => {
        //                 item.g.coordinates[2] = 0;
        //                 if(index % 10 == 0 && res[index + 1]) {
        //                     item.nextPoint = res[index + 1];
        //                 }
        //                 item.t = element.id;
        //                 item.target = element.targetDb;
        //                 item.sumNum = res.length;
        //             });
        //             if(tile) {
        //                 tile.clear();
        //                 this.render(tile, type, res);
        //             } else {
        //                 const tile = this.sceneRegister.scenes[type].addTile( element.id );
        //                 this.render(tile, type, res);
        //             }
        //             source.add(res, element.id);
        //             this.status = true;
        //         })
        //     }
        // });
    }
    getThemeSource(tiles,type,reload = false) {

        const partType = this.themeConfig[type].part||type;
        const source = this.sourceController.getSource(partType);
        const tileNum = this.tiles.tileNum;
        const sourceDataList = Object.keys(source.getData());

        for(let i=0;i<tiles.length;i++) {
            const ele = tiles[i];
            if(!sourceDataList.includes(`${ele.x}_${ele.y}`) || reload) {
                source.add([], `${ele.x}_${ele.y}`);
                this.themeServer({taskId: this.taskId, unitId: this.currUnitIds, type: [type], coords: [ele.x * tileNum, ele.y * tileNum, (ele.x + 1) * tileNum, (ele.y + 1) * tileNum]}).then(res => {
                    
                    let tile = this.sceneRegister.scenes[partType].getTile(`${ele.x}_${ele.y}`);
                    if(tile) { 
                        tile.clear();
                    } else {
                        tile = this.sceneRegister.scenes[partType].addTile(`${ele.x}_${ele.y}`);
                    }
                    this.render(tile, partType, res[type]);

                    source.add(res[type], `${ele.x}_${ele.y}`);
                    this.status = true;
                    if(this.visibleFilters[partType]) {
                        this.updateSceneVisible(tile,this.visibleFilters[partType]);
                    }

                });
            }
        }
    }
    getSource(tiles, type, reload = false) {
        const source = this.sourceController.getSource(type);
        const tileNum = this.tiles.tileNum;
        this.sceneRegister.clearSceneCache();
        const sourceDataList = Object.keys(source.getData());

        if(!this.sourceServe) return

        for(let i = 0; i < tiles.length; i++) {
            const ele = tiles[i];
            if(!sourceDataList.includes(`${ele.x}_${ele.y}`) || reload) {
                source.add([], `${ele.x}_${ele.y}`);
          
                this.sourceServe({taskId: this.taskId, unitId: this.currUnitIds, type: [type], coords: [ele.x * tileNum, ele.y * tileNum, (ele.x + 1) * tileNum, (ele.y + 1) * tileNum]}).then(res => {
                    let tile = this.sceneRegister.scenes[type].getTile(`${ele.x}_${ele.y}`);

                    const sourceData = JSON.parse(JSON.stringify(res[type])).map(i => {return this.featureReg[type].setFeature(i)});
                    source.add(sourceData, `${ele.x}_${ele.y}`);

                    if(tile) {
                        if(this.sceneRegister.scenes[type].relationFeatures) {
                            const relationFeatures = this.sceneRegister.scenes[type].relationFeatures;
                            relationFeatures.forEach(element => {
                                this.sceneRegister.scenes[element].clear();
                            });
                        }
                        tile.clear();
                        this.render(tile, type, res[type]);
                    } else {
                        tile = this.sceneRegister.scenes[type].addTile( `${ele.x}_${ele.y}`);
                        this.render(tile, type, res[type]);
                    }
                    // source.add(res[type], `${ele.x}_${ele.y}`);
                    this.status = true;
                    if(this.visibleFilters[type]) {
                        this.updateSceneVisible(tile,this.visibleFilters[type]);
                    }

                    if(res.callback) {
                      res.callback()
                    }
                  
                })
            }
        }
    }

    initfeedbackRender() {
        this.sceneRegister.addScene('feedback');
        this.sceneRegister.addScene('temporaryFeedback');
        this.sceneRegister.addScene('staticFeedback');
    }

    setStatus(Boolean) {
        this.status = Boolean;
    }

    scenesRender(viewer,camera) {
      if(!this.status && !viewer.status) {
          return false;
      }
      this.setVisible();
      this.status = false;
      viewer.status = false;
      viewer.featureRenderer.clear();
      viewer.labelRenderer.clear();
      const container = new ScenePack();
      if(viewer.isStatic) {
        container.add(this.sceneRegister.scenes.staticFeedback);
      }else {
        for(let key in this.sceneRegister.scenes) {
          if(key != 'feedback' && key != 'staticFeedback'&& this.sceneRegister.scenes[key].visible) {
              container.add(this.sceneRegister.scenes[key]);
          } 
          }
        if(this.sceneRegister.scenes.feedback && this.sceneRegister.scenes.feedback.visible) {
          container.add(this.sceneRegister.scenes.feedback);
        }
      }

      viewer.labelRenderer.render(container, camera);
      viewer.featureRenderer.render(container, camera);

    }
    render(sence, type, source) {
        this.datas[type] = [];
        let step = 500;
        const temp = source.splice(0, step);

     
        const instancedData = [];
        temp.forEach(element => {
            const featureEle = this.featureReg[type].setFeature(element);
            
            const renderEle = this.renderReg[type].getSymbol(featureEle);
            // this.datas[type].push(renderEle);
            if(renderEle.instancedData) {
                instancedData.push(renderEle.instancedData);
            }
            if(renderEle instanceof Array) {
                renderEle.forEach(item => {
                    if(item.featureType) {
                        this.sceneRegister.scenes[item.featureType].add(item);

                    } else {
                        sence.add(item);
                    }
                })
            } else {
                sence.add(renderEle);
            }
        });
        // 箭头几何使用instancedMesh渲染
        if(instancedData.length > 0 && this.renderReg[type].getInstancedMesh) {
            const instancedMesh = this.renderReg[type].getInstancedMesh(instancedData.flat());
            sence.add(instancedMesh);
        }
        this.setStatus(true);
        if(source.length > 0) {
            window.requestAnimationFrame(() => {
                this.render(sence, type, source);
            });
        }
    }

    clearSence(type) {
        if(this.sceneRegister.scenes[type]) {
            this.sceneRegister.scenes[type].clear();
            this.setStatus(true);
        }
    }
    temporaryRender(sence, data, isSymbol) {
        if(isSymbol) {
            data.forEach(element => {
                sence.add(element);
            });
        } else {
            for(let key in data) {
                const featureList = data[key];
                featureList.forEach(element => {
                    const featureEle = this.featureReg[key].setFeature(element);
                    
                    const renderEle = this.renderReg[key].getSymbol(featureEle);
                    // this.datas[type].push(renderEle);
                    if(renderEle instanceof Array) {
                        renderEle.forEach(item => {
                            sence.add(item);
                        })
                    } else {
                        sence.add(renderEle);
                    }
                });
            }
        }
    }
}
